import { Option } from "api/common/types/common.types";

export const YES_NO_OPTIONS: Option[] = [
  { label: "Yes", value: "true" },
  { label: "No", value: "false" },
];

export const YES_NO_MAYBE_OPTIONS: Option[] = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
  { label: "Maybe", value: "Maybe" },
];
